import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ErrorBoundary from '../common/ErrorBoundary';
import AIChatbot from '../common/AIChatbot';

const { Content } = Layout;

const MainLayout = () => {
  return (
    <Layout className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <Sidebar />
      <Layout>
        <Header />
        <Content className="bg-transparent">
          <ErrorBoundary>
            <div className="p-6">
              <Outlet />
            </div>
          </ErrorBoundary>
        </Content>
      </Layout>
      <AIChatbot />
    </Layout>
  );
};

export default MainLayout;
